import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { OVERLAY_AUTH_MVPD_START } from 'helpers/FilterHelper';
import { helperGetHomeUrl } from 'helpers/RouteHelper';

class MVPD extends Component {
  componentDidMount() {
    const { setLoading, setOverlay, setTriggerAuthCheck, toggleMvpdAuthOverlay } = this.props;
    if (setLoading) setLoading(true);
    if (setOverlay) setOverlay(OVERLAY_AUTH_MVPD_START, true);
    if (toggleMvpdAuthOverlay) {
      const options = {
        onAuthCheckComplete: ({ complete, success }) => {
          if (complete && success) {
            setOverlay(OVERLAY_AUTH_MVPD_START, false);
            browserHistory.push(helperGetHomeUrl());
          }
        },
        onOverlayClose: () => {
          setOverlay(OVERLAY_AUTH_MVPD_START, false);
          setTriggerAuthCheck(true);
          toggleMvpdAuthOverlay(false);
          browserHistory.push(helperGetHomeUrl());
        },
      };
      toggleMvpdAuthOverlay(true, options);
    }
  }

  componentWillUnmount() {
    const { setLoading } = this.props;
    if (setLoading) setLoading(false);
  }

  render() {
    return <div />;
  }
}

MVPD.defaultProps = {
  setLoading: null,
  setOverlay: null,
  setTriggerAuthCheck: null,
  toggleMvpdAuthOverlay: null,
};

MVPD.propTypes = {
  setLoading: PropTypes.func,
  setOverlay: PropTypes.func,
  setTriggerAuthCheck: PropTypes.func,
  toggleMvpdAuthOverlay: PropTypes.func,
};

export default MVPD;
